import {motion} from "motion/react";
import React from "react";

const Highlight_class =
    "absolute bg-[#EF8165] rounded-full inset-0 m-auto flex max-h-full max-w-full h-5 w-5";

export const Highlight = () => (
    <motion.div
        initial={{
            scale: 0,
            opacity: 0,
        }}
        animate={{
            scale: [0, 2.5],
            opacity: [0.5, 0],
        }}
        transition={{
            repeat: Infinity,
            repeatDelay: 1,
            repeatType: "loop",
        }}
        className={Highlight_class}
    />
);
